export const validateCardNumber = (cardNumber) => {
	let cardCompany = null;
	let checkSum = true;

	if (cardNumber.length < 12 || cardNumber.length > 19) {
		return false;
	}

	checkSum = checkSumCorrect(cardNumber);
	if (!checkSum) {
		return false;
	}
	cardCompany = checkCardCompany(cardNumber.toString());
	if (!cardCompany) {
		return false;
	}
	return true;
};

const checkSumCorrect = (cardNumber) => {
	let nulOffset = 0;
	let sum = 0;
	for (let i = 1; i <= cardNumber.length; i++) {
		let currentDigit = cardNumber.charAt(cardNumber.length - i) - nulOffset;
		if (i % 2 == 0) {
			currentDigit *= 2;
			currentDigit = currentDigit > 9 ? currentDigit - 9 : currentDigit;
			sum += currentDigit;
		} else {
			sum += currentDigit;
		}
	}

	return sum % 10 == 0;
};

const checkCardCompany = (creditCardNumber) => {
	let cardId = isVisa(creditCardNumber);
	if (cardId) return cardId;

	cardId = isMastercard(creditCardNumber);
	if (cardId) return cardId;

	cardId = isAmericanExpress(creditCardNumber);
	if (cardId) return cardId;

	cardId = isDiscoverCard(creditCardNumber);
	if (cardId) return cardId;

	cardId = isChinaUnionPay(creditCardNumber);
	if (cardId) return cardId;

	cardId = isDinersClubCarteBlanche(creditCardNumber);
	if (cardId) return cardId;

	cardId = isDinersClubInternational(creditCardNumber);
	if (cardId) return cardId;

	cardId = isDinersClubUsAndCanada(creditCardNumber);
	if (cardId) return cardId;

	cardId = isJCB(creditCardNumber);
	if (cardId) return cardId;

	cardId = isLaser(creditCardNumber);
	if (cardId) return cardId;

	cardId = isMaestro(creditCardNumber);
	if (cardId) return cardId;

	cardId = isSolo(creditCardNumber);
	if (cardId) return cardId;

	cardId = isSwitch(creditCardNumber);
	if (cardId) return cardId;

	cardId = isVisaElectron(creditCardNumber);
	if (cardId) return cardId;

	return cardId;
};

/**
 * Check if the credit card is a Visa. A Visa number has to start with a 4 and has to have a length of 13 or 16 digits. The number has to be validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isVisa = (creditCardNumber) => {
	if (creditCardNumber.length == 13 || creditCardNumber.length == 16) {
		if (creditCardNumber.startsWith("4")) {
			return "VISA";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Mastercard. A Mastercard number has to start with a number between 51 and 55 and has to have a length of 16. The number has to be validated with the Luhn
 * algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isMastercard = (creditCardNumber) => {
	if (creditCardNumber.length == 16) {
		let firstTwoDigits = Number.parseInt(creditCardNumber.substring(0, 2));
		if (firstTwoDigits >= 51 && firstTwoDigits <= 55) {
			return "MASTERCARD";
		}
	}

	return null;
};

/**
 * Check if the credit card is an American Express. An American Express number has to start with 34 or 37 and has to have a length of 15. The number has to be validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isAmericanExpress = (creditCardNumber) => {
	if (
		creditCardNumber.length == 15 &&
		(creditCardNumber.startsWith("34") || creditCardNumber.startsWith("37"))
	) {
		return "AMERICAN_EXPRESS";
	}

	return null;
};

/**
 * Check if the credit card is a Discover Card. A Discover Card number has to start with 6011, 622126-622925, 644-649 or 65 and has to have a length of 16. The number has to be validated with the
 * Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isDiscoverCard = (creditCardNumber) => {
	if (creditCardNumber.length == 16 && creditCardNumber.startsWith("6")) {
		let firstThreeDigits = Number.parseInt(
			creditCardNumber.substring(0, 3)
		);
		let firstSixDigits = Number.parseInt(creditCardNumber.substring(0, 6));
		if (
			creditCardNumber.startsWith("6011") ||
			creditCardNumber.startsWith("65") ||
			(firstThreeDigits >= 644 && firstThreeDigits <= 649) ||
			(firstSixDigits >= 622126 && firstSixDigits <= 622925)
		) {
			return "DISCOVER_CARD";
		}
	}

	return null;
};

/**
 * Check if the credit card is a China UnionPay. A China UnionPay number has to start with 622 (622126-622925) and has to have a length between 16 and 19. No further validation takes place.<br/>
 * <br/>
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isChinaUnionPay = (creditCardNumber) => {
	if (
		creditCardNumber.length >= 16 &&
		creditCardNumber.length <= 19 &&
		creditCardNumber.startsWith("622")
	) {
		let firstDigits = Number.parseInt(creditCardNumber.substring(0, 5));
		if (firstDigits >= 622126 && firstDigits <= 622925) {
			return "CHINA_UNIONPAY";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Diners Club Carte Blanche. A Diners Club Carte Blanche number has to start with a number between 300 and 305 and has to have a length of 14. The number has to be
 * validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isDinersClubCarteBlanche = (creditCardNumber) => {
	if (creditCardNumber.length == 14 && creditCardNumber.startsWith("30")) {
		let firstDigits = Number.parseInt(creditCardNumber.substring(0, 3));
		if (firstDigits >= 300 && firstDigits <= 305) {
			return "DINERS_CLUB_CARTE_BLANCHE";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Diners Club International. A Diners Club International number has to start with the number 36 and has to have a length of 14. The number has to be validated with
 * the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isDinersClubInternational = (creditCardNumber) => {
	if (creditCardNumber.length == 14 && creditCardNumber.startsWith("36")) {
		return "DINERS_CLUB_INTERNATIONAL";
	}

	return null;
};

/**
 * Check if the credit card is a Diners Club US & Canada. A Diners Club US & Canada number has to start with the number 54 or 55 and has to have a length of 16. The number has to be validated with
 * the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isDinersClubUsAndCanada = (creditCardNumber) => {
	if (
		creditCardNumber.length == 16 &&
		(creditCardNumber.startsWith("54") || creditCardNumber.startsWith("55"))
	) {
		return "DINERS_CLUB_US_AND_CANADA";
	}

	return null;
};

/**
 * Check if the credit card is a JCB. A JCB number has to start with a number between 3528 and 3589 and has to have a length of 16. The number has to be validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isJCB = (creditCardNumber) => {
	if (creditCardNumber.length == 16) {
		let firstFourDigits = Number.parseInt(creditCardNumber.substring(0, 4));
		if (firstFourDigits >= 3528 && firstFourDigits <= 3589) {
			return "JCB";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Laser. A Laser number has to start with 6304, 6706, 6771 or 6709 and has to have a length between 16 and 19 digits. The number has to be validated with the Luhn
 * algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isLaser = (creditCardNumber) => {
	if (creditCardNumber.length >= 16 && creditCardNumber.length <= 19) {
		if (
			creditCardNumber.startsWith("6304") ||
			creditCardNumber.startsWith("6706") ||
			creditCardNumber.startsWith("6771") ||
			creditCardNumber.startsWith("6709")
		) {
			return "LASER";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Maestro. A Maestro number has to start with 5018,5020,5038,6304,6759,6761 or 6763 and has to have a length between 12 and 19 digits. The number has to be validated
 * with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isMaestro = (creditCardNumber) => {
	if (creditCardNumber.length >= 12 && creditCardNumber.length <= 19) {
		if (
			creditCardNumber.startsWith("5018") ||
			creditCardNumber.startsWith("5020") ||
			creditCardNumber.startsWith("5038") ||
			creditCardNumber.startsWith("6304") ||
			creditCardNumber.startsWith("6759") ||
			creditCardNumber.startsWith("6761") ||
			creditCardNumber.startsWith("6763")
		) {
			return "MAESTRO";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Solo. A Solo number has to start with 6334 or 6767 and has to have a length of 16, 18 or 19 digits. The number has to be validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isSolo = (creditCardNumber) => {
	if (
		creditCardNumber.length == 16 ||
		creditCardNumber.length == 18 ||
		creditCardNumber.length == 19
	) {
		if (
			creditCardNumber.startsWith("6334") ||
			creditCardNumber.startsWith("6767")
		) {
			return "SOLO";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Switch. A Switch number has to start with 4903,4905,4911,4936,564182,633110,6333 or 6759 and has to have a length of 16, 18 or 19 digits. The number has to be
 * validated with the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isSwitch = (creditCardNumber) => {
	if (
		creditCardNumber.length == 16 ||
		creditCardNumber.length == 18 ||
		creditCardNumber.length == 19
	) {
		if (
			creditCardNumber.startsWith("4903") ||
			creditCardNumber.startsWith("4905") ||
			creditCardNumber.startsWith("4911") ||
			creditCardNumber.startsWith("4936") ||
			creditCardNumber.startsWith("564182") ||
			creditCardNumber.startsWith("633110") ||
			creditCardNumber.startsWith("6333") ||
			creditCardNumber.startsWith("6759")
		) {
			return "SWITCH";
		}
	}

	return null;
};

/**
 * Check if the credit card is a Visa Electron. A Visa Electron number has to start with 417500,4917,4913,4508 or 4844 and has to have a length of 16 digits. The number has to be validated with
 * the Luhn algorithm.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isVisaElectron = (creditCardNumber) => {
	if (
		creditCardNumber.length == 16 &&
		(creditCardNumber.startsWith("417500") ||
			creditCardNumber.startsWith("4917") ||
			creditCardNumber.startsWith("4913") ||
			creditCardNumber.startsWith("4508") ||
			creditCardNumber.startsWith("4844"))
	) {
		return "VISA_ELECTRON";
	}

	return null;
};

/**
 * Can be used (subclassed) to extend the test with a credit card not yet known by the validator.
 *
 * @param creditCardNumber
 *            the credit card number as a string
 * @return The credit card id of the issuer
 */
const isUnknown = (creditCardNumber) => {
	return null;
};



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/utils/ValidateCardNumber.ts